import { useAuth } from '../context/AuthContext';
import DashboardPersonal from './dashboards/DashboardPersonal';
import DashboardSystem from './dashboards/DashboardSystem';

export default function Dashboard() {
    const { user } = useAuth();
    const role = (user?.role || 'USER').toUpperCase();

    if (role === 'SYSTEM') return <DashboardSystem />;
    return <DashboardPersonal />;
}
